var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipoLesionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.32,
    height: 26.321,
    viewBox: "0 0 26.32 26.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12954",
    "data-name": "Group 12954",
    transform: "translate(-4370.108 -374.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7481",
    "data-name": "Path 7481",
    d: "M4378.932,391.59h-7.179c-.536,0-.644-.111-.644-.656q0-3.7,0-7.41c0-.485.123-.607.611-.607h7.212V375.7c0-.487.124-.611.608-.611h7.437c.516,0,.629.116.629.644v7.18h7.219c.482,0,.6.125.6.614q0,3.732,0,7.464c0,.466-.129.594-.6.594h-7.227v7.2c0,.5-.12.624-.622.624h-7.41c-.525,0-.642-.114-.642-.632V391.59Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#394f65",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoLesionImage);
export default __webpack_public_path__ + "static/media/tipo_lesion_image.afbf892e0e2dd5e8967a083628c3d9cc.svg";
export { ForwardRef as ReactComponent };